const idTranslation = {
  "loading": "Memuat...",
  "chatbot_title": "Selamat datang di chat baru Anda!",
  "chatbot_description": "Tanya soal akun media sosial Anda",
  "new_chat": "Chat Baru",
  "new_chat_title": "Judul Chat Baru",
  "search_chats": "Cari chat...",
  "send_message_placeholder": "Ketik pesan Anda...",
  "loading_assistant": "Memuat Asisten Anda...",
  "assistant_thinking": "Lema sedang berpikir...",
  "drafting_answer": "Menyusun jawaban...",
  "notify_when_done": "Mau Lema kasih notifikasi kalau sudah selesai?",
  "notify_me": "Beritahu saya",
  "notification_set": "Kami akan memberi tahu kamu",
  "send_instruction": "Tekan Enter untuk mengirim, Shift+Enter untuk baris baru",
  "select_chat_or_new": "Pilih chat atau buat yang baru",
  "attach_files": "Lampirkan file",
  "assistant": "Asisten",
  "you": "Anda",
  "sources": "Sumber",
  "citation": "Sitasi",
  "items": "item",
  "error_initializing_chatbot": "Kesalahan saat memulai chatbot:",
  "failed_fetch_history": "Gagal mengambil riwayat pesan:",
  "error_creating_chat": "Error saat membuat chat baru:",
  "failed_create_new_chat": "Gagal membuat chat baru:",
  "file_upload_error": "Kesalahan unggah file:",
  "error_uploading_file": "Kesalahan saat mengunggah file:",
  "conversation_not_found_new_one": "Percakapan tidak ditemukan, membuat yang baru",
  "error_creating_conversation": "Kesalahan saat membuat percakapan baru:",
  "error_sending_message": "Kesalahan saat mengirim pesan:",
  "error_regenerating_message": "Kesalahan saat membuat ulang pesan:",
  "conversation_error_try_again": "Maaf, terjadi kesalahan dengan percakapan. Silakan coba lagi.",
  "new_conversation_error_try_again": "Maaf, terjadi kesalahan saat membuat percakapan baru. Silakan coba lagi.",
  "processing_request_error_try_again": "Maaf, terjadi kesalahan saat memproses permintaan Anda. Silakan coba lagi.",
  "regenerating_message_error_try_again": "Maaf, terjadi kesalahan saat membuat ulang pesan. Silakan coba lagi.",
  "request_timed_out_try_again": "Permintaan habis waktu. Silakan coba lagi.",
  "generic_error": "Kesalahan:",
  "generic_processing_error_try_again": "Maaf, terjadi kesalahan saat memproses permintaan Anda.",
  "stop_generation": "Hentikan generasi",
  "stop": "Berhenti",
  "start_conversation": "Mulai percakapan",
  "cancel": "Batal",
  "save_edit": "Simpan",
  "download_file": "Unduh file",
  "no_chats_found": "Tidak ada chat yang cocok dengan pencarian Anda.",
  "no_chats_yet": "Belum ada chat. Mulai yang baru!",
  "rename_chat": "Ganti nama chat",
  "confirm_delete_chat": "Apakah Anda yakin ingin menghapus chat \"{{title}}\"?",
  "search": {
    "title": "Cari Brand",
    "placeholder": "Cari brand...",
    "search_button": "Cari",
    "loading": "Mencari brand...",
    "empty_state": "Masukkan kata kunci untuk menemukan peluang kolaborasi brand",
    "connect_title": "Hubungkan Akun Anda",
    "connect_description": "Hubungkan media sosial Anda agar Lema dapat menemukan sponsorship untuk Anda",
    "connect_button": "Ke Pengaturan Akun",
    "loading_search": "Memuat pencarian...",
    "visit_website": "Kunjungi Situs Web",
    "score": "Skor",
    "description": "Cari rekomendasi brand untuk kolaborasi dengan Anda",
    "error_label": "Kesalahan",
    "recommended_brands": "Rekomendasi Brand",
    "business": "Bisnis",
    "relevance": "Relevansi",
    "lead_score": "Skor",
    "profile": "Profil",
    "collapse_tooltip": "Klik untuk menyembunyikan",
    "expand_tooltip": "Klik untuk menampilkan",
    "results_range": "{{start}}-{{end}} dari {{total}} hasil",
    "zero_results": "0 hasil",
    "unexpected_response": "Format respons dari server tidak sesuai",
    "auth_required": "Diperlukan otentikasi. Silakan masuk lagi.",
    "connect_account_before_search": "Harap hubungkan akun media sosial sebelum mencari. Buka pengaturan akun Anda untuk menghubungkan akun.",
    "search_failed": "Gagal melakukan pencarian",
    "unexpected_error": "Terjadi kesalahan tak terduga",
    "recommendations_tab": "Rekomendasi",
    "history_tab": "Riwayat",
    "affiliate_recommendations": "Rekomendasi Afiliasi",
    "results": "hasil",
    "no_affiliate_recommendations": "Tidak ada rekomendasi afiliasi",
    "affiliate_recommendations.brands": "Brand",
    "affiliate_recommendations.description": "Deskripsi",
    "affiliate_recommendations.recommendation_score": "Skor",
    "affiliate_recommendations.commission_rate": "Komisi",
    "affiliate_recommendations.audience": "Audiens",
    "affiliate_recommendations.apply": "Daftar",
    "affiliate_recommendations.commission": "Komisi"
  },
  "delete_chat": "Hapus chat",
  "remove_file": "Hapus file",
  "uploading_files": "Mengunggah file...",
  "send_message": "Kirim pesan",
  "type_message_or_attach": "Ketik pesan atau lampirkan file",
  "send_instruction_short": "Enter untuk mengirim, Shift+Enter untuk baris baru",
  "like_message": "Sukai pesan",
  "remove_like": "Batal menyukai",
  "dislike_message": "Tidak sukai pesan",
  "remove_dislike": "Batal tidak menyukai",
  "copy_message": "Salin pesan",
  "reply_to_message": "Balas pesan",
  "edit_message": "Edit pesan",
  "regenerate_response": "Buat ulang respons",
  "drop_files_here": "Letakkan file di sini",
  "chats_title": "Chats",
  "jump_to_original": "Lompat ke semula",
  "replying_to": "Membalas ke",
  "error_file_too_large": "File melebihi batas {{maxSize}}: {{files}}",
  "error_compress_first": "Mohon kompres file tersebut terlebih dahulu atau coba file yang lebih kecil.",
  "agent": {
    "tools": {
      "find_brand_leads": "Cari brand untuk kolaborasi",
      "query_database": "Mengambil Data dari Database",
      "searching_web": "Mencari di Web",
      "creating_post": "Membuat Posting",
      "lead_gen_v9": "Mencari Brand",
      "google_instagram_search": "Mencari di Web",
      "create_post": "Membuat Posting",
      "query_supabase_v2": "Mengambil Data",
      "scrape_tiktok_profile": "Mengambil Profil TikTok",
      "scrape_instagram_profile": "Mengambil Profil Instagram",
      "link_captioner": "Memahami Tautan",
      "fetching_audience": "Mengambil Data Audiens",
      "deep_statistics_agent": "Menganalisis Statistik",
      "plan": "Rencana",
      "tool_call": "Panggilan Alat",
      "working": "Memproses"
    }
  },
  "indexing_messages": [
    "Mengambil data Anda...",
    "Memahami profil Anda...",
    "Mengindeks teks Anda...",
    "Menyimpan ke memori...",
    "Mengunduh gambar Anda...",
    "Mengunduh video Anda...",
    "Mengompres gambar Anda...",
    "Mengompres video Anda...",
    "Membuat embeddings untuk gambar Anda...",
    "Membuat embeddings untuk video Anda...",
    "Menyimpan ke memori...",
    "Mengolah data Anda..."
  ],
  "connect": {
    "title": "Hubungkan Akun Anda",
    "button": "Ke Pengaturan Akun",
    "chat_description": "Hubungkan media sosial Anda agar Lema dapat menemukan wawasan dan ngobrol dengan Anda",
    "portfolio_description": "Hubungkan akun sosial Anda untuk membuat portofolio."
  },
  "error": {
    "rate_limit_title": "Batas Limit Tercapai",
    "rate_limit_message": "Coba lagi dalam 1 menit atau upgrade ke paket berbayar untuk pengalaman lebih lancar",
    "rate_limit_monthly_exceeded": "Batas pesan bulanan Anda telah terlampaui. Silakan tingkatkan tier Anda untuk melanjutkan.",
    "rate_limit_wait_and_retry": "Terlalu banyak permintaan. Silakan tunggu dan coba lagi",
    "dify_agent_title": "Kesalahan Proses",
    "dify_agent_message": "Lema mengalami kesalahan. Buat ulang atau kirim pesan lain",
    "content_policy_title": "Lema mengalami kesalahan",
    "content_policy_message": "Buat ulang atau kirim pesan lain",
    "could_not_recover_response": "Lema masih menyusun responsmu. Silakan refresh halaman dalam beberapa menit.",
    "chat_rate_limit_exceeded": "Batas limit tercapai. Silakan tingkatkan paket Anda.",
    "chat_critical_error": "Terjadi kesalahan kritis.",
    "chat_regenerate_failed": "Kesalahan saat membuat ulang respons.",
    "chat_resend_failed": "Kesalahan saat mengirim ulang pesan.",
    "chat_stream_error": "Kesalahan Stream",
    "chat_read_stream_error": "Kesalahan saat membaca stream respons.",
    "chat_timeout": "Permintaan habis waktu. Silakan coba lagi.",
    "chat_no_response_body": "Tidak ada respons yang diterima",
    "chat_stop_streaming_failed": "Gagal menghentikan streaming",
    "chat_stream_error_title": "Koneksi Terputus",
    "chat_stream_error_message": "Koneksi terganggu. Ini mungkin masalah jaringan sementara. Silakan coba lagi.",
    "chat_init_chatbot_failed": "Kesalahan saat memulai chatbot",
    "chat_fetch_history_failed": "Gagal mengambil riwayat pesan",
    "chat_create_chat_failed": "Kesalahan saat membuat chat baru",
    "chat_create_conversation_failed": "Kesalahan saat membuat percakapan baru",
    "chat_send_message_failed": "Kesalahan saat mengirim pesan",
    "chat_conversation_error": "Maaf, terjadi kesalahan dengan percakapan. Silakan coba lagi.",
    "chat_new_conversation_error": "Maaf, terjadi kesalahan saat membuat percakapan baru. Silakan coba lagi.",
    "chat_processing_error": "Maaf, terjadi kesalahan saat memproses permintaan Anda. Silakan coba lagi.",
    "chat_generic_error": "Maaf, terjadi kesalahan saat memproses permintaan Anda.",
    "chat_recover_failed": "Tidak dapat memulihkan respons dari server. Silakan buat chat baru dan kirim pesan baru",
    "auth_verification_failed": "Verifikasi gagal. Silakan coba lagi.",
    "auth_google_signin_failed": "Gagal memulai masuk dengan Google. Silakan coba lagi.",
    "auth_google_signup_failed": "Gagal memulai pendaftaran dengan Google. Silakan coba lagi.",
    "auth_password_mismatch": "Kata sandi tidak cocok",
    "auth_session_expired": "Sesi Anda telah berakhir. Silakan masuk kembali.",
    "auth_sign_out_failed": "Gagal keluar",
    "auth_update_state_failed": "Gagal memperbarui status autentikasi",
    "auth_refresh_session_failed": "Gagal memperbarui sesi",
    "auth_init_auth_failed": "Gagal menginisialisasi autentikasi",
    "file_upload_failed": "Kesalahan mengunggah file",
    "file_too_large": "Ukuran file melebihi batas maksimum",
    "file_compress_first": "Silakan kompres file terlebih dahulu atau coba file yang lebih kecil.",
    "file_invalid_format": "Format file tidak valid",
    "file_caption_failed": "Captioning gagal",
    "file_caption_timeout": "Permintaan captioning habis waktu.",
    "file_caption_invalid_response": "Permintaan captioning berhasil tetapi respons tidak valid JSON.",
    "file_url_upload_failed": "Unggah URL gagal",
    "social_load_instagram_failed": "Gagal memuat data Instagram",
    "social_load_tiktok_failed": "Gagal memuat data TikTok",
    "social_load_youtube_failed": "Gagal memuat data YouTube",
    "social_disconnect_failed": "Gagal memutuskan akun",
    "social_connection_failed": "Koneksi gagal",
    "social_token_exchange_failed": "Pertukaran token gagal",
    "social_save_connection_failed": "Terjadi kesalahan saat menyimpan koneksi.",
    "social_fetch_accounts_failed": "Gagal mengambil akun",
    "social_select_account_failed": "Gagal memilih akun",
    "social_indexing_failed": "Indexing gagal",
    "social_indexing_timeout": "Indexing habis waktu saat menunggu penyelesaian",
    "social_fetch_timeout": "Pengambilan sosial habis waktu saat menunggu penyelesaian",
    "portfolio_enter_username": "Silakan masukkan username",
    "portfolio_user_not_found": "Username tidak ditemukan di sistem kami.",
    "portfolio_connect_first": "Silakan hubungkan akun terlebih dahulu di",
    "portfolio_generation_failed": "Gagal membuat portofolio",
    "portfolio_generic_error": "Terjadi kesalahan saat membuat portofolio",
    "portfolio_not_found_title": "Portofolio Tidak Ditemukan",
    "search_unexpected_response": "Menerima format respons yang tidak terduga dari server",
    "search_auth_required": "Autentikasi diperlukan. Silakan masuk kembali.",
    "search_connect_account_first": "Silakan hubungkan akun media sosial sebelum mencari. Pergi ke pengaturan akun Anda untuk menghubungkan akun.",
    "search_failed": "Gagal melakukan pencarian",
    "search_unexpected_error": "Terjadi kesalahan yang tidak terduga",
    "verification_rate_limit": "Silakan tunggu sebelum mencoba lagi",
    "verification_send_failed": "Gagal mengirim email verifikasi. Silakan coba lagi.",
    "subscription_already_active_title": "Langganan Aktif Ditemukan",
    "subscription_already_active_message": "Anda sudah memiliki langganan aktif. Silakan kelola langganan Anda dari halaman akun.",
    "general_unexpected_error": "Kami mohon maaf atas ketidaknyamanannya. Terjadi kesalahan yang tidak terduga.",
    "general_network_error": "Kesalahan jaringan. Silakan periksa koneksi Anda.",
    "general_timeout": "Permintaan habis waktu. Silakan coba lagi.",
    "general_unknown_error": "Terjadi kesalahan yang tidak diketahui",
    "general_fetch_failed": "Gagal mengambil data",
    "general_save_failed": "Gagal menyimpan perubahan",
    "general_load_failed": "Tidak dapat memuat data saat ini."
  },
  "success": {
    "auth_sign_in_success": "Berhasil masuk",
    "auth_sign_out_success": "Berhasil keluar",
    "auth_verification_sent": "Email verifikasi terkirim",
    "social_connected": "Akun berhasil terhubung",
    "social_disconnected": "Akun berhasil terputus",
    "social_indexing_complete": "Indexing berhasil diselesaikan",
    "portfolio_generated": "Portofolio berhasil dibuat",
    "file_uploaded": "File berhasil diunggah",
    "chat_message_sent": "Pesan berhasil terkirim"
  },
  "warning": {
    "file_size_warning": "File besar terdeteksi. Pertimbangkan untuk mengompres sebelum mengunggah.",
    "file_format_warning": "Format file ini mungkin tidak didukung.",
    "social_disconnection_warning": "Memutuskan akan menghapus akses ke data Anda.",
    "social_indexing_in_progress": "Indexing sedang berlangsung. Jangan tutup halaman ini.",
    "chat_long_response": "Membuat respons detail. Ini mungkin memakan waktu sebentar.",
    "chat_incomplete_response_title": "Stream Terganggu",
    "chat_incomplete_response": "Respons tidak lengkap. Refresh untuk pesan lengkap."
  },
  "common": {
    "close": "Tutup",
    "collapse_sidebar": "Sembunyikan sidebar",
    "close_sidebar": "Tutup sidebar",
    "scroll_to_view": "Geser untuk melihat",
    "click_days_for_details": "Klik tanggal untuk detail konten",
    "explore_idea_deeper": "Eksplorasi Ide Lebih Dalam",
    "swipe_to_scroll": "Geser untuk menelusuri",
    "click_arrows_to_scroll": "Klik panah untuk menelusuri"
  },
  "rate_limit_exceeded": "Batas pesan bulanan Anda telah terlampaui. Silakan tingkatkan tier Anda untuk melanjutkan.",
  "nav": {
    "pricing": "Harga",
    "chat": "Chat",
    "search": "Cari",
    "portfolio": "Portofolio",
    "account": "Akun",
    "signOut": "Keluar",
    "signIn": "Masuk",
    "getStarted": "Mulai Gratis",
    "features": "Fitur",
    "about": "Tentang",
    "demo": "Demo",
    "openMainMenu": "Buka menu utama",
    "expandChatHistory": "Perluas riwayat chat",
    "dataStatus": {
      "connected": "Data terhubung",
      "needsUpdate": "Data perlu diperbarui",
      "loading": "Data sedang dimuat",
      "notConnected": "Data belum terhubung",
      "checking": "Memeriksa status data...",
      "labelNotConnected": "Data belum terhubung"
    }
  },
  "auth": {
    "signup_title": "Mulai Gratis",
    "signup_subtitle": "Tenang, tidak perlu menghubungkan akun media sosial 😉",
    "field_required": "Harap isi kolom ini.",
    "email_label": "Email",
    "password_label": "Kata sandi",
    "repeat_password_label": "Ulangi kata sandi",
    "email_placeholder": "kamu@contoh.com",
    "password_placeholder": "********",
    "repeat_password_placeholder": "********",
    "creating_account": "Membuat akun...",
    "continue_with_email": "Lanjut dengan email",
    "continue_with_google": "Lanjut dengan Google",
    "or": "Atau",
    "already_have_account": "Sudah punya akun?",
    "sign_in": "Masuk",
    "error_password_mismatch": "Kata sandi tidak cocok",
    "error_verification_failed": "Verifikasi gagal. Silakan coba lagi.",
    "error_google_signup_failed": "Gagal memulai pendaftaran Google. Silakan coba lagi.",
    "connecting": "Menghubungkan...",
    "signin_title": "Masuk",
    "forgot_password": "Lupa kata sandi?",
    "dont_have_account": "Belum punya akun?",
    "sign_up": "Daftar",
    "signing_in": "Masuk...",
    "error_google_signin_failed": "Gagal memulai masuk Google. Silakan coba lagi.",
    "oauth_blocked_title": "Masuk Google diblokir",
    "oauth_blocked_description": "Google tidak mengizinkan masuk dari browser in-app karena alasan keamanan. Salin link di bawah dan buka di Safari atau Chrome.",
    "oauth_blocked_step1": "Ketuk \"Salin link\" di bawah",
    "oauth_blocked_step2": "Buka Safari atau Chrome",
    "oauth_blocked_step3": "Tempel link dan masuk",
    "oauth_blocked_email_fallback": "Atau masuk dengan email",
    "copy_link": "Salin link",
    "in_app_browser_notice_prefix": "Jika Anda ingin masuk dengan Google, buka kembali",
    "in_app_browser_notice_suffix": "dengan browser pilihan Anda (Chrome / Firefox / Safari) di luar aplikasi {{browserName}}",
    "copied": "Tersalin!"
  },
  "connectPopup": {
    "title": "Hubungkan akun",
    "subtitle": "Hindari error karena data tidak ditemukan dan hasil analisa yang lebih baik",
    "providers": {
      "instagram": {
        "name": "Instagram",
        "description": "Hubungkan akun Instagram Anda."
      },
      "youtube": {
        "name": "YouTube",
        "description": "Hubungkan akun YouTube Anda."
      },
      "tiktok": {
        "name": "TikTok",
        "description": "Hubungkan akun TikTok Anda."
      }
    },
    "active_accounts": "{{count}} aktif",
    "connect_button": "Koneksi Aman"
  },
  "portfolio": {
    "title": "Generator Portofolio",
    "description": "Buat portofolio profesional untuk media sosial Anda",
    "instagram_username_label": "Nama Pengguna Instagram",
    "username_placeholder": "nama pengguna",
    "error_enter_username": "Silakan masukkan nama pengguna Instagram",
    "error_user_not_found": "Nama pengguna tidak ditemukan di sistem kami.",
    "error_connect_first": "Harap hubungkan akun terlebih dahulu di",
    "error_generation_failed": "Gagal membuat portofolio",
    "error_generic": "Terjadi kesalahan saat membuat portofolio",
    "generating": "Membuat Portofolio...",
    "generate_button": "Buat Portofolio Baru",
    "publicly_accessible_at": "Portofolio yang dihasilkan akan dapat diakses publik di",
    "existing_portfolio_title": "Portofolio yang Ada",
    "visit_button": "Kunjungi",
    "preview_title": "Pratinjau Portofolio",
    "connect_title": "Hubungkan Akun Anda",
    "connect_description": "Hubungkan media sosial Anda untuk membuka pembuatan portofolio yang dipersonalisasi dan menampilkan konten Anda",
    "connect_button": "Ke Pengaturan Akun"
  },
  "portfolioDisplay": {
    "loading": "Memuat portofolio...",
    "not_found_title": "Portofolio Tidak Ditemukan",
    "generate_new": "Buat Portofolio Baru",
    "audience": "Audiens",
    "niche_performance": "Performa Niche",
    "metrics": {
      "followers": "pengikut",
      "engagement": "engagement",
      "average_views": "rata-rata views",
      "peak_views": "views tertinggi",
      "average_views_label": "RATA-RATA VIEWS",
      "engagement_label": "ENGAGEMENT",
      "per_post_in_niche": "Per post di Niche"
    },
    "contact_me": "Hubungi Saya",
    "no_contact_info": "Tidak ada informasi kontak"
  },
  "landing": {
    "placeholder_profile_link": "Link ke profil Instagram / TikTok...",
    "placeholder_brands": "Brand kerajinan tangan...",
    "action_button_evaluate": "(Evaluasi profil saya)",
    "action_button_find_brand": "(Cari sponsorship brand)",
    "action_button_engagement": "(Hitung engagement rate)",
    "action_text_evaluate": "Evaluasi profil saya",
    "action_text_find_brand": "Cari Sponsorship Brand",
    "action_text_engagement": "Hitung Engagement Rate",
    "action_text_create_script": "Buat Skrip",
    "prompt_create_content_calendar": "buatkan kalender konten 10 hari untuk",
    "placeholder_evaluate": "Ketik link Instagram / TikTok / YouTube Anda",
    "placeholder_find_brand": "Ketik brand yang Anda inginkan",
    "placeholder_engagement": "Ketik link Instagram / TikTok / YouTube Anda",
    "placeholder_create_script": "Ketik link Instagram / TikTok / YouTube Anda",
    "press_enter_to_ask_ai": "Tekan Enter untuk bertanya pada Lema",
    "hero_title": "Lema: AI untuk Kreator",
    "hero_subtitle_prefix": "Creator Companion yang",
    "hero_subtitle_cocreate": "berkreasi bersamamu, kapan saja",
    "hero_subtitle_analytics": "menguraikan analitikmu",
    "hero_subtitle_available": "memahami semua kontenmu",
    "overview_title": "AI Pendamping Kamu",
    "overview_description": "AI yang sudah menonton semua kontenmu, selalu siap berkreasi bersama, dan menginterpretasi datamu agar kamu tidak perlu repot.",
    "continuation_text": "Dengan melanjutkan, Anda menyetujui",
    "terms_of_service": "syarat layanan",
    "privacy_policy": "kebijakan privasi",
    "features_title": "Yang Lema Lakukan Untukmu",
    "features_subtitle": "AI pendampingmu, dibuat untuk kreator",
    "feature_cocreate_title": "Berkreasi Bersama",
    "feature_cocreate_description": "Brainstorm, tulis skrip, dan sempurnakan kontenmu dengan AI yang benar-benar tahu karyamu.",
    "animation_cocreate_user": "Video masak berikutnya harus tentang apa?",
    "animation_cocreate_lema_before": "Berdasarkan reels terbaikmu, ",
    "animation_cocreate_lema_highlight": "resep DIY dengan instruksi langkah demi langkah",
    "animation_cocreate_lema_after": " mendapat +90% lebih banyak likes.",
    "animation_cocreate_tip1": "Coba tutorial nastar homemade",
    "animation_cocreate_tip2": "Tambahkan hook perbandingan harga",
    "feature_understand_data_title": "Pahami Datamu",
    "feature_understand_data_description": "Cari tahu apa yang berhasil dan mengapa — untuk keputusan konten yang lebih cerdas.",
    "feature_always_there_title": "Menemani Perjalananmu",
    "feature_always_there_description": "Butuh pendapat kedua? Editing terasa berat? Lema selalu ada untukmu.",
    "platforms_title": "Kami Mendukung Kreator di",
    "platforms_subtitle": "Instagram, TikTok, dan YouTube",
    "pricing_title": "Harga",
    "pricing_subtitle": "Pilih paket yang paling cocok untuk Anda.",
    "billing_monthly": "Bulanan",
    "billing_yearly": "Tahunan",
    "pricing_plans": {
      "free": {
        "title": "Gratis",
        "button_text": "Mulai",
        "price_description": "per bulan"
      },
      "pro": {
        "title": "Pro",
        "button_text": "Pilih Paket",
        "price_description": "per bulan",
        "monthly_price": "Rp300.000",
        "yearly_price": "Rp240.000",
        "yearly_helper": "(ditagih tahunan) total {{idr}} per tahun"
      },
      "pro_plus": {
        "title": "Pro+",
        "button_text": "Pilih Paket",
        "price_description": "per bulan",
        "monthly_price": "Rp900.000",
        "yearly_price": "Rp720.000",
        "yearly_helper": "(ditagih tahunan) total {{idr}} per tahun"
      }
    },
    "pricing_features": {
      "credits_free": "30 kredit yang bisa Anda gunakan untuk",
      "credits_pro": "100 kredit yang bisa Anda gunakan untuk",
      "credits_pro_plus": "500 kredit yang bisa Anda gunakan untuk",
      "brainstorm_growth": "Brainstorm cara mengembangkan profil Anda",
      "analyze_performance": "Analisis kenapa konten bekerja dengan baik / tidak",
      "generate_content_ideas": "Buat ide konten",
      "search_brands_collab": "Tanya apa saja yang ingin kamu ketahui!"
    },
    "pricing_recommended": "Rekomendasi",
    "pricing_redirecting": "Mengalihkan...",
    "about_title": "Tentang Kami",
    "about_team_title": "Tim Kami",
    "about_team_body": "Kami adalah tim dua founder (mantan tim konten & ML Meta, Oxford + Huawei Research).",
    "about_name_origin_title": "Asal Nama",
    "about_name_origin_body": "Kenapa namanya Lema? Dalam matematika, \"lemma\" adalah teorema kecil yang menjadi alat untuk membuktikan teorema yang lebih besar. Kami percaya orang harus bisa mencari nafkah dari hal yang mereka sukai, dan Lema adalah alat kami untuk membuktikannya.",
    "about_impact_title": "Dampak",
    "stat_founded": "Didirikan",
    "stat_creators_served": "Kreator yang Dilayani",
    "stat_brand_deals_closed": "Brand Deal yang Tercapai",
    "about_support_body": "Kami mencintai pembuatan konten dan ingin mendukung perjalanan kreator konten kamu",
    "about_talk_button": "Ngobrol langsung dengan kami",
    "try_it_now": "Coba sekarang",
    "animation": {
      "views_up": "Views naik — hook kuat",
      "shares_dip": "Shares turun — angle kontroversial",
      "saves_spike": "Saves naik — tips praktis",
      "reach_drops": "Reach turun — opening lemah",
      "comments_up": "Komentar naik — momen relatable",
      "likes_dip": "Likes turun — pesan kurang jelas"
    },
    "vs_title": "Kenapa Lema, Bukan ChatGPT?",
    "vs_title_prefix": "Kenapa Lema, Bukan",
    "vs_subtitle": "Kebanyakan AI tidak dirancang untuk kreator. Lema iya.",
    "vs_creators_title": "Belajar dari Kreator Terbaik",
    "vs_creators_description": "Lema mempelajari cara kreator dengan engagement tinggi menjangkau audiens secara konsisten — dari data kreator nyata, bukan dari konten web umum.",
    "vs_video_title": "Benar-Benar Menonton Video",
    "vs_video_description": "Tempel link video dan Lema sungguh-sungguh menontonnya. AI lain sering tidak bisa dan hanya mengarang.",
    "vs_personal_title": "Mengenal Akunmu",
    "vs_personal_description": "Lema terhubung ke datamu dan memberi saran berdasarkan konten yang sudah kamu posting. Bukan saran klise seperti \"posting lebih sering\" atau \"ikuti tren\".",
    "vs_animation_patterns_header": "Sinyal kreator terbaik",
    "vs_patterns_industry_cooking": "Kreator memasak terbaik",
    "vs_pattern_cooking_1": "Demonstrasi sains / lab",
    "vs_pattern_cooking_2": "Tutorial langkah-demi-langkah",
    "vs_pattern_cooking_3": "Konten resep + DIY",
    "vs_patterns_industry_beauty": "Kreator kecantikan terbaik",
    "vs_pattern_beauty_1": "Transformasi sebelum & sesudah",
    "vs_pattern_beauty_2": "Rutinitas GRWM",
    "vs_pattern_beauty_3": "Review produk drugstore",
    "vs_patterns_industry_travel": "Kreator perjalanan terbaik",
    "vs_pattern_travel_1": "Ungkap destinasi tersembunyi",
    "vs_pattern_travel_2": "Tips wisata hemat",
    "vs_pattern_travel_3": "Vlog sehari-hari",
    "vs_patterns_industry_fitness": "Kreator kebugaran terbaik",
    "vs_pattern_fitness_1": "Koreksi gerakan latihan",
    "vs_pattern_fitness_2": "Seri tantangan 30 hari",
    "vs_pattern_fitness_3": "Kombinasi meal prep + workout",
    "vs_patterns_industry_lifestyle": "Kreator gaya hidup terbaik",
    "vs_pattern_lifestyle_1": "POV rutinitas pagi",
    "vs_pattern_lifestyle_2": "Transformasi kamar",
    "vs_pattern_lifestyle_3": "Panduan produktivitas",
    "vs_animation_patterns_footer": "Lema belajar dari pola ini",
    "vs_animation_video_watching": "Menonton...",
    "vs_animation_video_done": "✓ Dianalisis",
    "vs_animation_video_tag_1": "Format tutorial",
    "vs_animation_video_tag_2": "Hook kuat di 0:03",
    "vs_animation_video_tag_3": "Call-to-action jelas",
    "vs_animation_personal_label": "Untukmu",
    "vs_animation_personal_followers": "{{count}} pengikut",
    "vs_animation_personal_insight_label": "Insight",
    "vs_animation_personal_insight_text": "Video di bawah 1 menit dengan 70%+ narasi punya retensi dan rata-rata waktu tonton lebih tinggi.",
    "vs_animation_personal_insight_text_2": "Tutorial langkah demi langkah mendapat simpanan 3× lebih banyak dibanding konten lifestyle-mu.",
    "vs_animation_personal_insight_text_3": "Konten dengan teks caption di layar mendapat 45% lebih banyak tayangan ulang dari penonton baru.",
    "vs_animation_personal_scanning": "Menganalisis...",
    "vs_animation_personal_analyzed": "Dianalisis"
  },
  "authVerifyEmail": {
    "titleDefault": "Periksa email Anda",
    "titleSent": "Email terkirim!",
    "descriptionDefault": "Kami telah mengirim email konfirmasi ke {{email}}",
    "descriptionSent": "Kami telah mengirim ulang email konfirmasi ke {{email}}",
    "noEmailTitle": "Verifikasi Diperlukan",
    "noEmailDescription": "Silakan daftar untuk menerima email verifikasi.",
    "backToSignUp": "Kembali ke Daftar",
    "bodyIntro": "Silakan klik tautan di email untuk verifikasi akun dan menyelesaikan pendaftaran.",
    "bodyExpiry": "Tautan akan kedaluwarsa dalam 24 jam.",
    "notReceived": "Tidak menerima email? Cek folder spam atau",
    "resendCta": "Kirim ulang email verifikasi",
    "sending": "Mengirim...",
    "rateLimitError": "Silakan tunggu sebelum mencoba lagi",
    "genericError": "Gagal mengirim email verifikasi. Silakan coba lagi.",
    "rateLimitCountdown": "Silakan tunggu {{seconds}} detik sebelum mencoba lagi",
    "continueToSignIn": "Lanjut ke Masuk"
  },
  "account": {
    "title": "Pengaturan Akun",
    "no_accounts_found": "Tidak Ada Akun Instagram Ditemukan",
    "no_threads_accounts_found": "Tidak Ada Akun Threads Ditemukan",
    "connect_methods_message": "Hubungkan akun Anda dengan:",
    "connecting": "Menghubungkan...",
    "connect_with_facebook": "Hubungkan Instagram lewat Facebook",
    "connect_with_instagram": "Hubungkan langsung lewat Instagram",
    "connect_with_threads": "Hubungkan dengan Threads",
    "no_tiktok_accounts_found": "Tidak Ada Akun TikTok Ditemukan",
    "connect_with_tiktok": "Hubungkan dengan TikTok",
    "connect_with_tiktok_business": "Hubungkan Akun Bisnis TikTok Anda",
    "no_youtube_accounts_found": "Tidak Ada Akun YouTube Ditemukan",
    "connect_with_youtube": "Hubungkan dengan YouTube",
    "go_back_to_account": "← Kembali ke Halaman Akun",
    "select_account_title": "Pilih Akun Instagram Anda",
    "select_account_description": "Pilih akun Instagram Profesional mana yang ingin Anda gunakan dengan Lema",
    "no_professional_accounts_found": "Tidak Ada Akun Profesional Instagram Ditemukan",
    "no_professional_accounts_description": "Tidak ada Akun Profesional Instagram yang ditemukan terhubung ke akun Facebook Anda.",
    "retrying": "Mencoba lagi...",
    "try_again": "Coba Lagi",
    "processing": "Memproses...",
    "continue": "Lanjutkan",
    "instagram_professional_accounts": "Akun Profesional Instagram",
    "report_issues": "Harap laporkan masalah dan / atau umpan balik ke",
    "connect_social_accounts": "Hubungkan Akun Media Sosial Anda",
    "usage": {
      "title": "Ringkasan Penggunaan",
      "usage_since": "Penggunaan sejak {{date}}",
      "loading": "Memuat data penggunaan…",
      "plan_label": "Paket",
      "unused": "Belum digunakan",
      "of_limit_used": "/{{limit}} terpakai",
      "available": "{{limit}} tersedia",
      "left": "Sisa {{count}}",
      "unlimited": "Tanpa batas",
      "error_unable_to_load": "Tidak dapat memuat data penggunaan saat ini.",
      "retry": "Coba lagi",
      "credits_title": "Kredit Penggunaan",
      "credits_description": "Jatah bulanan untuk paket {{tier}}.",
      "need_more": {
        "title": "Butuh lebih banyak?",
        "description": "Pro memberikan Anda 100 kredit per bulan dan Pro+ memberikan 500 kredit per bulan.",
        "upgrade_pro": "Upgrade ke Pro",
        "upgrade_pro_plus": "Upgrade ke Pro+",
        "cancel_subscription": "Batalkan Langganan",
        "contact_for_credits": "Hubungi Kami untuk Kredit Tambahan"
      },
      "cancel_dialog": {
        "title": "Batalkan Langganan",
        "message": "Akun Anda akan diturunkan ke Free dan tidak ada pengembalian dana. Lanjutkan?",
        "confirm": "Konfirmasi",
        "cancel": "Batal",
        "canceling": "Membatalkan...",
        "success": "Langganan berhasil dibatalkan",
        "error": "Gagal membatalkan langganan"
      },
      "upgrade_dialog": {
        "title": "Konfirmasi Upgrade Langganan",
        "message": "Upgrade dari {{currentPlan}} (${{currentPrice}}/bulan) ke {{newPlan}} (${{newPrice}}/bulan) dengan {{newCredits}} kredit per bulan. Anda akan ditagih secara proporsional untuk sisa periode ini.",
        "confirm": "Konfirmasi Upgrade",
        "cancel": "Batal",
        "upgrading": "Mengupgrade..."
      },
      "upgrade_success": "Langganan berhasil diupgrade!",
      "plan_names": {
        "free": "Gratis",
        "pro": "Pro",
        "pro_plus": "Pro+"
      }
    },
    "password_panel_title": "Ubah / Buat Kata Sandi",
    "password_panel_description": "untuk login email & kata sandi",
    "password_change_title": "Ubah kata sandi",
    "password_set_title": "Buat kata sandi",
    "password_set_description": "untuk mengaktifkan login email & kata sandi",
    "update_password_button": "Perbarui Kata Sandi",
    "set_password_button": "Buat Kata Sandi",
    "password_updating": "Memperbarui...",
    "password_change_cta": "Ubah kata sandi",
    "password_set_cta": "Buat kata sandi"
  },
  "chat": {
    "title": "Tanyakan tentang akun media sosial Anda",
    "placeholder": "Ajukan pertanyaan...",
    "send_instruction": "Tekan Enter untuk mengirim, Shift+Enter untuk baris baru",
    "explore_deeper_single": "Eksplorasi lebih dalam {{titles}}",
    "explore_deeper_multiple": "Eksplorasi lebih dalam ide-ide ini: {{titles}}",
    "quick_actions": {
      "open_last_chat": "Buka percakapan terakhir",
      "lead_search": "Cari lead sponsorship",
      "collab_of_the_week": "Kolaborasi pekan ini",
      "engagement_rate": "Engagement rate 30 hari terakhirku?",
      "create_video": "Buat video dari post terbaikku",
      "most_viewed_post": "Kenapa post paling viral bisa laku?",
      "evaluate_profile": "Evaluasi profil & strategi kontenku",
      "next_video_type": "Post apa yang cocok berikutnya?",
      "grow_followers": "Cara nambah followers bulan ini?",
      "find_brand_sponsorship_deals": "Cari tawaran sponsorship brand",
      "find_sponsorships": "Lihat rekomendasi kolaborasi minggu ini",
      "create_portfolio": "Buat situs portofoliomu",
      "tutorial": "Apa saja yang bisa kamu lakukan?",
      "create_content_plan": "Buat kalender konten 10 hari",
      "compare_highest_lowest": "Bandingkan post dengan views tertinggi dan terendah 30 hari terakhir",
      "optimize_bio": "Optimalkan bio ku"
    }
  },
  "portfolioViews": {
    "title": "Tampilan portofolio",
    "last_24_hours": "24 jam terakhir",
    "loading": "Memuat statistik tampilan...",
    "total_views": "Total tampilan",
    "unique_viewers": "Pengunjung unik",
    "empty": "Belum ada tampilan tercatat. Bagikan tautan portofolio Anda untuk mulai melacak."
  },
  "account_social": {
    "disconnect": "Putuskan",
    "disconnect_aria": "Putuskan akun",
    "update_ai": "Perbarui data Lema",
    "update_ai_aria": "Memperbarui Lema",
    "instagram_direct": "Koneksi Langsung",
    "instagram_via_facebook": "Via Facebook",
    "facebook_connected": "Facebook terhubung",
    "no_instagram_professional": "tetapi tidak ada Akun Profesional Instagram ditemukan. Pastikan halaman Facebook Anda memiliki Akun Profesional Instagram yang terhubung.",
    "change_instagram_account": "Ganti Akun Instagram",
    "unlock_analytics": "✨ Perbarui model analitik mendalam",
    "unlock_analytics_locked": "🔒 Aktifkan Analitik Mendalam",
    "unlock_analytics_aria": "Buka prediksi konten dan analitik lanjutan",
    "unlock_analytics_loading": "Menganalisis...",
    "unlock_analytics_modal_title": "Buka Prediksi Konten & Analitik Lanjutan",
    "unlock_analytics_modal_description": "Dapatkan prediksi views dan likes untuk ide kontenmu serta penjelasan detail mengapa kontenmu berhasil (misal: tampil wajah +20% views)",
    "unlock_analytics_modal_cta": "Upgrade ke Pro"
  },
  "account_indexing": {
    "instagram": {
      "checking": "Memeriksa akun Instagram Anda...",
      "analyzing": "Menganalisis strategi konten Anda...",
      "gathering_insights": "Mengumpulkan wawasan dari posting Anda...",
      "learning_audience": "Mempelajari preferensi audiens Anda...",
      "organizing": "Mengatur data media sosial Anda...",
      "finalizing": "Hampir selesai, menyelesaikan profil Anda..."
    },
    "tiktok": {
      "checking": "Memeriksa akun TikTok Anda...",
      "analyzing": "Menganalisis tren konten Anda...",
      "gathering_insights": "Mengumpulkan wawasan dari video Anda...",
      "learning_audience": "Mempelajari preferensi audiens Anda...",
      "organizing": "Mengatur data media sosial Anda...",
      "finalizing": "Hampir selesai, menyelesaikan profil Anda..."
    },
    "youtube": {
      "checking": "Memeriksa kanal YouTube Anda...",
      "analyzing": "Menganalisis performa konten Anda...",
      "gathering_insights": "Mengumpulkan wawasan dari video Anda...",
      "learning_audience": "Mempelajari preferensi audiens Anda...",
      "organizing": "Mengatur data kanal Anda...",
      "finalizing": "Hampir selesai, menyelesaikan profil Anda..."
    }
  },
  "agent_thinking": {
    "agent": "Agen",
    "analyzing_user_question": "Menganalisis Pertanyaan Pengguna",
    "applying_socmed_best_practices": "Menerapkan Praktik Terbaik Media Sosial",
    "researching_platform": "Meneliti Platform",
    "diving_to_data": "Mendalami Data",
    "thinking": "Berpikir...",
    "planning": "Merencanakan...",
    "understanding": "Memahami...",
    "processing": "Memproses...",
    "working": "Mengerjakan..."
  },
  "agent_tools": {
    "get_schema_and_table": "Mengambil Skema dan Tabel",
    "lead_gen_v9": "Mencari Brand",
    "google_instagram_search": "Mencari di Web",
    "google_ig_tt_yt_search": "Mencari di Web",
    "create_post": "Membuat Posting",
    "query_supabase_v2": "Mengambil Data",
    "query_database": "Mengambil Data dari Database",
    "scrape_tiktok_profile": "Mengambil Profil TikTok",
    "scrape_instagram_profile": "Mengambil Profil Instagram",
    "scrape_youtube_profile": "Mengambil Profil YouTube",
    "link_captioner": "Memahami Tautan",
    "cobalt_link": "Mengonversi Tautan",
    "fetch_youtube_video_detail": "Mengambil Video YouTube",
    "fetching_audience": "Mengambil Data Audiens",
    "fetch_audience": "Mengambil Data Audiens",
    "deep_statistics_agent": "Menganalisis Statistik",
    "searching_web": "Mencari di Web",
    "creating_post": "Membuat Posting",
    "query_caption": "Mengambil Gaya Menulis Kreator",
    "tool_call": "Panggilan Alat"
  }
};

export default idTranslation;
